module.exports = __webpack_public_path__ + "static/media/teaser-das-steckt-drin.a98ecd26.jpg";